// @ts-ignore
import mixpanel from 'mixpanel-browser';

export default {
  install(Vue: any, options: any) {
    Vue.prototype.$mixpanel= mixpanel
  }
}
